import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import {
  Box,
  Button,
  Tab,
  TablePagination,
  Tabs,
  useMediaQuery,
} from '@material-ui/core'
import { Plus as PlusIcon } from 'react-feather'

import {
  Container,
  ContentHeader,
  FilterButton,
  LoadingFeedback,
  Page,
  Permitted,
  Card,
} from 'components'
import { ChurnsTable, ChurnFilter } from './components'

import { routes } from 'Routes'
import useFetch from 'hooks/useFetch'
import useFilter from 'hooks/useFilter'
import { usePagination } from 'hooks'

import constants from 'constants/index'
import * as service from 'service'
import theme from 'theme'

const ChurnsMain = () => {
  const filter = useFilter()
  const history = useHistory()

  const [loading, setLoading] = useState(false)
  const [tab, setTab] = useState('all')

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination()

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const handleCreate = () => history.push(routes.churns.create)

  const handleChangeTab = (_, value) => {
    setTab(value)
    handleChangePage(null, 0)
  }

  const { response, isLoading, refresh } = useFetch(
    service.dponet.churns.get,
    {
      ...{ ...filter.filters },
      statusIn: tab === 'all' ? undefined : [tab],
      perPage,
      page,
    },
    [page, perPage, filter.filters, tab],
  )

  return (
    <Page title="Listagem de solicitações de churns">
      <LoadingFeedback open={isLoading || loading} />
      <Container maxWidth={false}>
        <ContentHeader
          menu="Solicitações de churns"
          title="Listagem"
          subtitle="Solicitações de churns"
          filter={filter}
          notSpecificTags
        >
          <FilterButton setDrawerOpen={filter.setDrawerOpen} />
        </ContentHeader>
        <Box mt={4}>
          <Tabs
            value={tab}
            onChange={handleChangeTab}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="Todos" value="all" />
            {constants.churn.STATUSES.map((status) => (
              <Tab
                key={status}
                label={constants.churn.STATUS_LABEL_TRANSLATION[status]}
                value={status}
              />
            ))}
          </Tabs>
        </Box>
        <Card
          title="Solicitações de Churns"
          actionButton={
            <Permitted tag={constants.permissions.CHURNS.CREATE}>
              <Button
                variant="outlined"
                color="primary"
                startIcon={<PlusIcon />}
                onClick={handleCreate}
              >
                Criar
              </Button>
            </Permitted>
          }
        >
          <ChurnsTable
            churns={response?.data?.churns || []}
            refresh={refresh}
            setIsLoading={setLoading}
          />
          <Box px={2} display="flex" justifyContent="flex-end">
            <TablePagination
              component="div"
              count={response?.data?.meta?.totalCount || 0}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              page={page - 1}
              rowsPerPage={perPage}
              rowsPerPageOptions={[5, 10, 25, 100]}
              labelRowsPerPage={isDesktop ? 'Por página' : ''}
              nextIconButtonProps={{ size: 'small' }}
              backIconButtonProps={{ size: 'small' }}
            />
          </Box>
        </Card>
      </Container>
      <ChurnFilter filter={filter} />
    </Page>
  )
}

export default ChurnsMain
